import React from "react";

import ButtonWithPopover from "../ButtonWithPopover";

import Button from "react-bootstrap/Button";

import "../PawStatus/PawStatus.css";

const CompleteLinkingButton = ({ completeLinking, faxId, disallowEditing }) => {
  const handleCompleteLinking = () => {
    completeLinking(faxId);
  };

  const reference = "completeLinking";

  return (
    <ButtonWithPopover
      placement="top"
      customRef={reference + "bwp"}
      buttonVariant="success"
      buttonText="Complete Linking"
      buttonIsBlock={true}
      buttonIsDisabled={disallowEditing}
      popoverTitle="Complete Linking"
      buttonId="unprocessable-fax-details-btn-complete-linking-popover"
    >
      <p className="confirmation-text">
        Do you want to <b>complete linking</b> this fax? This will finalize all linked pages.
      </p>
      <div className="align-content-right">
        <Button
          id="switchdetails-btn-complete-linking"
          className="left-spacer"
          variant="success"
          onClick={handleCompleteLinking}
        >
          Complete Linking
        </Button>
      </div>
    </ButtonWithPopover>
  );
};

export default CompleteLinkingButton;

